import React from 'react';
import CorporateUserManagement from '../Corporate/UserManagement/UserManagement';
import StandardUserManagement from './UserManagement';

/**
 * UserManagement Wrapper Component
 * Conditionally renders Corporate or Standard User Management based on environment variable
 */
const UserManagementWrapper = () => {
    // Check if corporate mode is enabled
    const isCorporateMode = process.env.REACT_APP_CORPORATE_MODE === 'true';

    // Get user email from localStorage or session (adjust based on your auth implementation)
    const userEmail = localStorage.getItem('userEmail') || sessionStorage.getItem('userEmail') || '';

    if (isCorporateMode) {
        // Render Corporate User Management
        return <CorporateUserManagement userEmail={userEmail} />;
    } else {
        // Render Standard User Management
        return <StandardUserManagement />;
    }
};

export default UserManagementWrapper;
